import { supabase } from './supabaseClient';
import { montoParaBD } from '../utils/validacion';

import { getNegocioId } from './negocioActual';
import { fechaLocal } from '../utils/fecha';

// Ventas libres / otros ingresos: dinero que entra SIN tocar inventario
// (venta de algo no registrado, consultorías, etc.). Se contabilizan
// separado de las ventas de producto para no distorsionar la utilidad real.
export async function obtenerIngresosLibres({ desde = null } = {}) {
  let query = supabase
    .from('ingresos_libres')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('fecha', { ascending: false });
  if (desde) query = query.gte('fecha', desde);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}

// Un ingreso libre por id (para precargar el formulario de edición).
export async function obtenerIngresoPorId(id) {
  const { data, error } = await supabase
    .from('ingresos_libres')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
}

// El ingreso entra a la cuenta de forma atómica (función registrar_ingreso_libre).
export async function registrarIngresoLibre({ concepto, monto, cuentaId, clienteId, metodoPago, fecha, canal, descuento, envio, costo }) {
  const { data, error } = await supabase.rpc('registrar_ingreso_libre', {
    p_negocio_id: getNegocioId(),
    p_concepto: concepto?.trim(),
    p_monto: montoParaBD(monto, { nombre: 'monto del ingreso' }),
    p_cuenta_id: cuentaId || null,
    p_cliente_id: clienteId || null,
    p_metodo_pago: metodoPago || null,
    p_fecha: fecha || fechaLocal(),
    p_canal: canal || null,
    p_descuento: parseFloat(descuento) || 0,
    p_envio: parseFloat(envio) || 0,
    p_costo: parseFloat(costo) || 0,
  });
  if (error) throw error;
  return data;
}

// Elimina un ingreso libre con reverso atómico: saca de la cuenta el
// dinero que había entrado y borra su movimiento (función eliminar_ingreso_libre).
export async function eliminarIngresoLibre(id) {
  const { error } = await supabase.rpc('eliminar_ingreso_libre', {
    p_negocio_id: getNegocioId(),
    p_referencia: String(id),
  });
  if (error) throw error;
}

// Edita un ingreso libre: revierte el dinero viejo y aplica los datos nuevos (atómico).
export async function editarIngresoLibre(id, { concepto, monto, cuentaId, clienteId, metodoPago, fecha, canal, descuento, envio, costo }) {
  const { data, error } = await supabase.rpc('editar_ingreso_libre', {
    p_negocio_id: getNegocioId(),
    p_referencia: String(id),
    p_concepto: concepto?.trim(),
    p_monto: montoParaBD(monto, { nombre: 'monto del ingreso' }),
    p_cuenta_id: cuentaId || null,
    p_cliente_id: clienteId || null,
    p_metodo_pago: metodoPago || null,
    p_fecha: fecha || null,
    p_canal: canal || null,
    p_descuento: parseFloat(descuento) || 0,
    p_envio: parseFloat(envio) || 0,
    p_costo: parseFloat(costo) || 0,
  });
  if (error) throw error;
  return data;
}
